/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSourceTagRequest
 */
export interface CreateSourceTagRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSourceTagRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSourceTagRequest
     */
    name: string;
}

/**
 * Check if a given object implements the CreateSourceTagRequest interface.
 */
export function instanceOfCreateSourceTagRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CreateSourceTagRequestFromJSON(json: any): CreateSourceTagRequest {
    return CreateSourceTagRequestFromJSONTyped(json, false);
}

export function CreateSourceTagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSourceTagRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CreateSourceTagRequestToJSON(value?: CreateSourceTagRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

